// ============================================================
// EN ORDRE — comportements partagés des sections (V2)
// ============================================================
document.addEventListener('DOMContentLoaded', function () {

  // Scroll reveal — only hide-then-animate if this script actually runs.
  // Elements stay visible by default (see eo-theme.css); we only add
  // .eo-pending here, right before observing, so nothing can get stuck hidden.
  var revealEls = document.querySelectorAll('.eo-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.remove('eo-pending');
          e.target.classList.add('eo-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) {
      el.classList.add('eo-pending');
      io.observe(el);
    });
  }

  // Sticky add-to-cart bar (appears once the hero section is scrolled past)
  var stickyBar = document.getElementById('eo-sticky-bar');
  var heroSection = document.querySelector('.eo-hero, .eo-product-hero');
  if (stickyBar && heroSection) {
    window.addEventListener('scroll', function () {
      var heroBottom = heroSection.getBoundingClientRect().bottom;
      if (heroBottom < 0) { stickyBar.classList.add('eo-show'); }
      else { stickyBar.classList.remove('eo-show'); }
    }, { passive: true });
  }

  // UGC videos: play on scroll into view, pause otherwise
  var videos = document.querySelectorAll('.eo-ugc-video');
  if (videos.length && 'IntersectionObserver' in window) {
    var videoIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.play().catch(function(){}); }
        else { e.target.pause(); }
      });
    }, { threshold: 0.5 });
    videos.forEach(function (v) { videoIo.observe(v); });
  }
});

function eoToggleMute(btn) {
  var video = btn.previousElementSibling;
  video.muted = !video.muted;
  btn.textContent = video.muted ? '\u{1F507}' : '\u{1F50A}';
}

// ---------- Funnel intelligent (quiz 2 questions) ----------
var eoFunnelState = {};

function eoFunnelAnswer(key, val) {
  eoFunnelState[key] = val;
  if (key === 'etat') {
    document.getElementById('eo-step-1').classList.remove('eo-active');
    document.getElementById('eo-step-2').classList.add('eo-active');
    document.getElementById('eo-fp1').style.width = '100%';
  } else if (key === 'freq') {
    document.getElementById('eo-step-2').classList.remove('eo-active');
    document.getElementById('eo-step-result').classList.add('eo-active');
    document.getElementById('eo-fp2').style.width = '100%';
    eoShowFunnelResult();
  }
}

function eoShowFunnelResult() {
  var etat = eoFunnelState.etat, freq = eoFunnelState.freq;
  var score = 0;
  if (etat === 'moyen') score += 1;
  if (etat === 'chaos') score += 2;
  if (freq === 'parfois') score += 1;
  if (freq === 'souvent') score += 2;

  var title = document.getElementById('eo-rec-title');
  var text = document.getElementById('eo-rec-text');
  var cta = document.getElementById('eo-rec-cta');
  if (!title || !text || !cta) return;

  var data = window.eoFunnelData || {};
  var rec = score <= 1 ? data.solo : (score <= 3 ? data.duo : data.trio);
  if (rec) {
    title.textContent = rec.title;
    text.textContent = rec.text;
    cta.setAttribute('href', rec.href || '#eo-pricing');
  }
}

function eoFunnelRestart() {
  eoFunnelState = {};
  document.getElementById('eo-step-result').classList.remove('eo-active');
  document.getElementById('eo-step-1').classList.add('eo-active');
  document.getElementById('eo-fp1').style.width = '0%';
  document.getElementById('eo-fp2').style.width = '0%';
}
